var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "", justify: "space-between" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "7" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200px",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-accounts",
                              title: _vm.getTitle
                                ? `${_vm.getTitle}`
                                : `Создать пользователя`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-tabs",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        _vm._l(_vm.tabs, function (tab) {
                          return _c(
                            "v-tab",
                            {
                              key: tab.value,
                              attrs: { disabled: tab.isDisabled },
                            },
                            [_vm._v(" " + _vm._s(tab.title) + " ")]
                          )
                        }),
                        1
                      ),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "PageContent",
                                { attrs: { height: "80" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-container",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Email пользователя*"
                                                    ),
                                                  ]),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      id: "email",
                                                      outlined: "",
                                                      value: _vm.fields.email,
                                                      autofocus:
                                                        !_vm.fields.email,
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .email,
                                                      loading: _vm.loading,
                                                      disabled: _vm.disabled,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.$v.fields.email.$touch()
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.fields.email,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "email",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.email",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Логин пользователя*"
                                                    ),
                                                  ]),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      id: "login",
                                                      outlined: "",
                                                      value: _vm.fields.login,
                                                      autofocus:
                                                        !_vm.fields.login,
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .login,
                                                      loading: _vm.loading,
                                                      disabled: _vm.disabled,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.$v.fields.login.$touch()
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.fields.login,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "login",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.login",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Телефон пользователя*"
                                                    ),
                                                  ]),
                                                  _c("v-text-field", {
                                                    directives: [
                                                      {
                                                        name: "phone",
                                                        rawName:
                                                          "v-phone:withEmail",
                                                        arg: "withEmail",
                                                      },
                                                    ],
                                                    attrs: {
                                                      id: "phone",
                                                      outlined: "",
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .phone,
                                                      loading: _vm.loading,
                                                      disabled: _vm.disabled,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.$v.fields.phone.$touch()
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.fields.phone,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "phone",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.phone",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Пароль"),
                                                  ]),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      id: "password",
                                                      name: "password",
                                                      counter: "",
                                                      outlined: "",
                                                      autocomplete:
                                                        "new-password",
                                                      loading: _vm.loading,
                                                      disabled: _vm.disabled,
                                                      "append-icon":
                                                        _vm.isPasswordShown
                                                          ? "mdi-eye"
                                                          : "mdi-eye-off",
                                                      type: _vm.isPasswordShown
                                                        ? "text"
                                                        : "password",
                                                      hint: `Длина пароля должна быть не менее ${_vm.minPasswdLength} символов`,
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .password,
                                                    },
                                                    on: {
                                                      "click:append": function (
                                                        $event
                                                      ) {
                                                        _vm.isPasswordShown =
                                                          !_vm.isPasswordShown
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.fields.password,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "password",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.password",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          !_vm.isNew && _vm.data
                                            ? _c("UserAccount", {
                                                attrs: {
                                                  loading: _vm.loading,
                                                  data: _vm.data,
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "PageContent",
                                [
                                  _c(
                                    "v-card-text",
                                    _vm._l(_vm.roles, function (role) {
                                      return _c(
                                        "v-row",
                                        {
                                          key: role.id,
                                          attrs: {
                                            "no-gutters": "",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "hide-details": "",
                                              dense: "",
                                              label: role.name,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                              "input-value":
                                                _vm.roleIdList.includes(
                                                  role.id
                                                ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.updateRoleHandler(
                                                  role.id,
                                                  _vm.roleIdList.includes(
                                                    role.id
                                                  )
                                                )
                                              },
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _vm.isNew
                    ? _c("ManageSidePanel", {
                        ref: "manageSidePanel",
                        attrs: {
                          isLocales: false,
                          "is-new": _vm.isNew,
                          "is-loading": _vm.loading,
                          "is-submit-disabled":
                            _vm.activeTab ===
                              _vm.tabs.findIndex(
                                (tab) => tab.value === "roles"
                              ) || _vm.disabled,
                        },
                        on: {
                          cancel: function ($event) {
                            return _vm.$router.push({ name: "page-accounts" })
                          },
                          submit: _vm.submit,
                        },
                      })
                    : _vm.data
                    ? _c("ManageSidePanel", {
                        ref: "manageSidePanel",
                        attrs: {
                          isLocales: false,
                          "is-new": !_vm.data.id,
                          "created-at": _vm.data.createdAt,
                          "updated-at": _vm.data.updatedAt,
                          "is-loading": _vm.loading,
                          "is-submit-disabled":
                            _vm.activeTab ===
                              _vm.tabs.findIndex(
                                (tab) => tab.value === "roles"
                              ) || _vm.disabled,
                          "entity-id": _vm.data.id,
                          "entity-type": "account",
                        },
                        on: {
                          delete: function ($event) {
                            return _vm.$emit("delete-account")
                          },
                          cancel: function ($event) {
                            return _vm.$router.push({ name: "page-accounts" })
                          },
                          submit: _vm.submit,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "body",
                            fn: function () {
                              return [
                                _c(
                                  "v-card",
                                  { attrs: { flat: "" } },
                                  [
                                    _c(
                                      "v-card-subtitle",
                                      { staticClass: "grey--text" },
                                      [_vm._v("Связи")]
                                    ),
                                    _c(
                                      "v-card-text",
                                      [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-expansion-panels",
                                              [
                                                _c(
                                                  "v-expansion-panel",
                                                  [
                                                    _c(
                                                      "v-expansion-panel-header",
                                                      [
                                                        _vm._v(
                                                          "Профили (" +
                                                            _vm._s(
                                                              _vm.getCountProfiles
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-expansion-panel-content",
                                                      [
                                                        _c(
                                                          "RelationComponent",
                                                          {
                                                            attrs: {
                                                              culturalOrganizations:
                                                                _vm.getCulturalOrganizations,
                                                              eventOrganizers:
                                                                _vm.getEventOrganizers,
                                                              guides:
                                                                _vm.getGuides,
                                                              hotels:
                                                                _vm.getHotels,
                                                              touristAgencies:
                                                                _vm.getTouristAgencies,
                                                              loading:
                                                                _vm.loading,
                                                              disabled:
                                                                _vm.disabled,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          [
                                            _c("RelationsAccount", {
                                              attrs: {
                                                profiles: _vm.profiles,
                                                sharedAccess: _vm.sharedAccess,
                                                reservations: _vm.reservations,
                                                ticketReservations:
                                                  _vm.ticketReservations,
                                                loading: _vm.loading,
                                                disabled: _vm.disabled,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }